<template>
	<div id="UploadImage">
		<el-form>
			<el-form-item>
				<el-upload 
					class="avatar-uploader"
					action="string" :show-file-list="false" :http-request="UploadImage" :on-success="handleAvatarSuccess"
				 :before-upload="beforeAvatarUpload">
					<img v-if="imageUrl" :src="imageUrl" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'UploadImage',
		data() {
			return {
				imageUrl: "",
			}
		},
		methods: {
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传文件只能是图片格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			UploadImage(param) {
				const formData = new FormData()
				formData.append('file', param.file);
				this.axiosPostUploadImage(" http://app.dev.huaxiweiying.com/HXXCServiceAdmin/receipt/upload", formData).then((response) => {
					
					this.imageUrl = response.data.url;
					this.$emit("getImgUrl",response.data.url);
					// param.onSuccess() // 上传成功的图片会显示绿色的对勾
					// param.onError();
					
				})
			},
		},
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/UploadImage.vue